import { backendApi } from "./backendApi.rtkq";

export interface UserProfile {
  id: string;
  firebaseUid: string;
  email: string;
  displayName: string;
  phoneNumber?: string | null;
  isSuperAdmin: boolean;
  tosAcceptedVersion?: string;
  tosAcceptedAt?: string;
  officeRoles: Array<{
    officeId: string;
    role: string;
    officeName?: string;
  }>;
}

export interface RegisterResponse {
  user: { id: string; email: string; displayName: string; isSuperAdmin: boolean };
  office: { id: string; name: string; slug: string; subscriptionStatus: string };
  officeRole: { role: string };
  isNewRegistration: boolean;
  claimsUpdated: boolean;
}

export const usersApi = backendApi.injectEndpoints({
  endpoints: (builder) => ({
    getMe: builder.query<UserProfile, void>({
      query: () => "/users/me",
      providesTags: ["Users"],
    }),

    register: builder.mutation<
      RegisterResponse,
      { tosVersion: string; displayName?: string; officeName?: string }
    >({
      query: (body) => ({
        url: "/users/register",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Users", "Accounts"],
    }),

    switchOffice: builder.mutation<
      { officeId: string; role: string; officeName?: string; claimsUpdated: boolean },
      { officeId: string }
    >({
      query: (body) => ({
        url: "/users/me/switch-office",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Users", "Accounts", "Cases", "Members", "Dashboard"],
    }),

    leaveOffice: builder.mutation<{ left: boolean; officeId: string }, string>({
      query: (officeId) => ({
        url: `/users/me/leave-office/${officeId}`,
        method: "POST",
      }),
      invalidatesTags: ["Users", "Accounts"],
    }),

    updateMyPhone: builder.mutation<
      { id: string; phoneNumber: string | null },
      { phoneNumber: string }
    >({
      query: (body) => ({
        url: "/users/me/phone",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Users", "Dashboard"],
    }),
  }),
});

export const {
  useGetMeQuery,
  useRegisterMutation,
  useSwitchOfficeMutation,
  useLeaveOfficeMutation,
  useUpdateMyPhoneMutation,
} = usersApi;
